import React, { useEffect, useState } from "react";
import {
  Table,
  Input,
  Button,
  Space,
  Tag,
  Pagination,
  Dropdown,
  Menu,
  Spin,
  Form,
  Select,
  message,
  Modal,
  Row,
  Col,
  Radio,
} from "antd";
import Highlighter from "react-highlight-words";
import {
  ArrowDownOutlined,
  ArrowUpOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { professionalAction } from "../_actions";
import _ from "lodash";
import { ImageView } from "../Pages/image/imageView";

import { LanguageContext } from "../context/LanguageContext";
import FindAccusedBaseSearchTable from "../Pages/FindAccusedPage/FindAccusedBaseSearchTable";
import FilterData from "./FilterData";
import { ViewGunaDetails } from "../Pages/viewGunaDetails/viewGunaDetails";
import { connect } from "react-redux";
import moment from "moment";
import * as XLSX from "xlsx-js-style";
import { PoliceSideActions } from "../_actions/police.side.actions";
const { Option } = Select;

class AppTable extends React.Component {
  static contextType = LanguageContext;
  formRef = React.createRef();
  state = {
    searchText: "",
    searchedColumn: "",
    total: 0,
    pageSize: 10,
    currentPage: 0,
    criminalList1: [],
    data: [],
    orderDirection: "",
    search: false,
    tableLoading: false,
    filterData: [],
    imageOpen: false,
    selectedImage: null,
    crimeTitle: [],
    selectedHeadings: [],
    showGunaDetails: false,
    gunaLoading: false,
    download: "excel",
    year: [],
    is_photo: false,
    photoStatus: "",
    is_download: false,
    selectedFilter: "",
    orderBy: "",
    is_guna: false,
    searchGuna: "",
    select_dropdown: "search_name",
    selectedPoliceStation: "",
    kayda: "",
    kalam: [],
    main_head: [],
    select_main_head: "",
    crime_type: [],
  };
  isLoading = false;

  handleChange = (value) => {
    this.setState({ download: value });
    this.formRef.current.setFieldsValue({ condition: value }); // sync Form
  };

  handleFinish = (values) => {
    console.log("Form Submitted:", values);
    console.log("State Value:", this.state.download);
  };

  getMainHead = () => {
    professionalAction.getMainHead().then((res) => {
      console.log("res", res.data);
      this.setState({
        main_head: res.data,
      });
    });
  };
  getCrimeTitleByTitleId = (id) => {
    professionalAction.getCrimeTitleByTitleId(id).then((res) => {
      console.log("res", res.pc_crimeTypes);
      this.setState({
        crime_type: res.pc_crimeTypes,
      });
    });
  };

  downloadReport = () => {
    const { download } = this.state;
    if (download == "guna_excel") {
      this.download_csv1();
    }
    if (download == "arophi_excel" || download === "excel") {
      this.download_csv();
    }
  };

  getCityName = (id) => {
    const { pc_cities } = this.props && this.props.professionals;
    if (pc_cities && pc_cities.length) {
      return (
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0].City
      );
    }
  };

  getDistrictsid = (id) => {
    const { user } = this.props;
    console.log("users id", this.props);
    professionalAction.getDistrictsid(user.districtId).then((res) => {
      console.log("res", res);

      const tempData = res.pc_districts;
      console.log("text", tempData[0]?.DistrictName);
      this.setState({
        district_name: tempData[0]?.DistrictName,
      });
    });
  };
  handlePageSizeChange = (current, size) => {
    this.setState(
      {
        pageSize: size,
        currentPage: current,
      },
      () => {
        this.searchfilter(this.state.orderBy, this.state.orderDirection);
      }
    );
  };
  handleMainHead = (e) => {
    this.setState({ select_main_head: e });
    this.getCrimeTitleByTitleId(e);
  };

  componentDidMount() {
    const { user } = this.props;
    if (user && user.role !== "4") {
      this.getDistrictsid();
      this.getPoliceStationWithGhatak();
    }
    this.getMainHead();
  }
  download_csv1 = () => {
    const { t, language } = this.context;
    const report_name = "Accused_Details";
    const file_name = `${report_name}_${moment().format("DDMMMYYYY")}`;
    const report_title = "आरोपीची माहिती";

    const headerStyle = {
      font: { bold: true, sz: 14, color: { rgb: "000000" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin", color: { rgb: "000000" } },
        bottom: { style: "thin", color: { rgb: "000000" } },
        left: { style: "thin", color: { rgb: "000000" } },
        right: { style: "thin", color: { rgb: "000000" } },
      },
    };

    const showSubheading = this.state.selectedFilter === "लघु शीर्षक";

    const headers = [
      t("sr.no"),
      "Id",
      t("name"),
      t("address"),
      t("age"),
      t("mobile_number"),
      t("accused_police_station"),
      t("total_crimes"),
      t("photo"),
      t("history"),
    ];

    if (showSubheading) {
      headers.push(t("sub_title"));
    }

    headers.push(
      t("title"),
      t("crime_police_station"),
      t("crime_register_number"),
      t("crime_register_year"),
      t("crime_registration_date"),
      t("law_and_section"),
      t("preventive_action"),
      t("current_status"),
      t("date_from"),
      t("date_to")
    );

    const totalCols = headers.length;
    const accusedFixedCols = showSubheading ? 11 : 10; // Adjusted for subheading
    const lawColIndex = showSubheading ? 16 : 15;

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet([]);
    let merges = [];

    // Get city and state names with fallback
    const cityName =
      this.getCityName(this.props?.user?.cityId || "") || "Unknown City";
    const stateName = this.state.district_name || "Unknown State";
    const headerData = `${stateName} (${cityName})`;

    // Add city name to sheet
    XLSX.utils.sheet_add_aoa(ws, [[headerData]], { origin: "A1" });
    ws["A1"].s = headerStyle;
    merges.push({ s: { r: 0, c: 0 }, e: { r: 0, c: totalCols - 1 } });

    // Add report title
    XLSX.utils.sheet_add_aoa(ws, [[report_title]], { origin: "A2" });
    ws["A2"].s = headerStyle;
    merges.push({ s: { r: 1, c: 0 }, e: { r: 1, c: totalCols - 1 } });

    let dataOrigin = "A3";
    let headerRowIndex = 2; // 0-based for merges

    // Add date range if not history_sheeter
    if (this.state.report_type !== "history_sheeter" && this.state.from_date) {
      const dateRange = `${moment(this.state.from_date).format("DD/MM/YYYY")}`;
      XLSX.utils.sheet_add_aoa(ws, [[dateRange]], { origin: "A3" });
      ws["A3"].s = headerStyle;
      merges.push({ s: { r: 2, c: 0 }, e: { r: 2, c: totalCols - 1 } });
      dataOrigin = "A4";
      headerRowIndex = 3;
    }

    const ws_data = [headers];
    let rowIndex = headerRowIndex + 1; // 0-based index for first data row

    // Process report data
    const reportData = Array.isArray(this.state.filterData)
      ? this.state.filterData
      : [];
    reportData.forEach((accused, idx) => {
      const gunhas = Array.isArray(accused.gunha_records)
        ? accused.gunha_records
        : [];
      const preventive_actions = Array.isArray(accused.preventive_records)
        ? accused.preventive_records
        : [];
      gunhas.sort(
        (a, b) => new Date(b.dateTime || 0) - new Date(a.dateTime || 0)
      );

      const subheadings = Array.isArray(accused.subheadings)
        ? accused.subheadings
        : [];
      const subheading = subheadings.length > 0 ? subheadings.join(", ") : "-";
      const rowspan = Math.max(gunhas.length + preventive_actions.length, 1); // Ensure at least one row

      // Process gunha_records (crime records)
      gunhas.forEach((gunha, gIndex) => {
        const row = [];
        if (gIndex === 0) {
          row.push(idx + 1); // Sr. No.
          row.push(accused.masterId || "-");
          row.push(accused.name || "-");
          row.push(accused.address || "-");
          row.push(accused.age || "-");
          row.push(accused.mobileNumber || "-");
          row.push(accused.districtName || "-");
          row.push(accused.totalCrimeCount || "-");
          row.push(
            Array.isArray(accused.photo) &&
              accused.photo.length &&
              accused.photo[0] !== ""
              ? t("yes")
              : t("no")
          );
          row.push(accused.historySheeter == 1 ? t("yes") : t("no"));
          if (showSubheading) {
            row.push(subheading);
          }
        } else {
          for (let i = 0; i < accusedFixedCols; i++) row.push("");
        }

        row.push(gunha.crime_title || "-");
        row.push(gunha.districtName || "-");
        row.push(gunha.registernumber || "-");
        row.push(
          gunha.registernumberYear
            ? moment(gunha.registernumberYear).format("YYYY")
            : "-"
        );
        row.push(
          gunha.dateTime ? moment(gunha.dateTime).format("DD/MM/YYYY") : "-"
        );

        // Law and Section
        let lawData = "-";
        if (Array.isArray(gunha.kk_info) && gunha.kk_info.length > 0) {
          const grouped = {};
          gunha.kk_info.forEach((rule) => {
            const name = rule.rulesName || "-";
            const kalma = rule.kalam || "-";
            if (!grouped[name]) {
              grouped[name] = [kalma];
            } else if (!grouped[name].includes(kalma)) {
              grouped[name].push(kalma);
            }
          });
          lawData = Object.entries(grouped)
            .map(([name, kalmas]) => `${name}: ${kalmas.join(", ")}`)
            .join("\n");
        }
        row.push(lawData);

        // Leave preventive action fields blank for gunha records
        row.push("");
        row.push("");
        row.push("");
        row.push("");

        ws_data.push(row);
      });

      // Process preventive_action records
      preventive_actions.forEach((action, aIndex) => {
        const row = [];
        if (aIndex === 0 && gunhas.length === 0) {
          row.push(idx + 1);
          row.push(accused.masterId || "-");
          row.push(accused.name || "-");
          row.push(accused.address || "-");
          row.push(accused.age || "-");
          row.push(accused.mobileNumber || "-");
          row.push(accused.districtName || "-");
          row.push(accused.totalCrimeCount || "-");
          row.push(
            Array.isArray(accused.photo) &&
              accused.photo.length &&
              accused.photo[0] !== ""
              ? "Yes"
              : "No"
          );
          row.push(accused.historySheeter == 1 ? t("yes") : t("no"));
          if (showSubheading) {
            row.push(subheading);
          }
        } else {
          for (let i = 0; i < accusedFixedCols; i++) row.push("");
        }

        // Leave crime-related fields blank for preventive actions
        row.push("");
        row.push("");
        row.push("");
        row.push("");
        row.push("");
        row.push("");

        // Preventive action fields
        row.push(action.preventive_action_name || "-");
        const currentDate = moment();
        const dateTo = action.date_to ? moment(action.date_to) : null;
        const status = dateTo
          ? dateTo.isBefore(currentDate, "day")
            ? t("completed")
            : t("ongoing")
          : "-";
        row.push(status);
        row.push(
          action.date_from ? moment(action.date_from).format("DD/MM/YYYY") : "-"
        );
        row.push(
          action.date_to ? moment(action.date_to).format("DD/MM/YYYY") : "-"
        );

        ws_data.push(row);
      });

      // Add merges for accused details if rowspan > 1
      if (rowspan > 1) {
        for (let col = 0; col < accusedFixedCols; col++) {
          merges.push({
            s: { r: rowIndex, c: col },
            e: { r: rowIndex + rowspan - 1, c: col },
          });
        }
      }

      rowIndex += rowspan;
    });

    // Add footer
    const footerContent = `Generated At ${moment().format(
      "DD MMM YYYY"
    )} From Criminal Monitoring Intelligent System`;
    const footerRowIndex = rowIndex;
    XLSX.utils.sheet_add_aoa(ws, [[footerContent]], {
      origin: `A${footerRowIndex + 1}`,
    });
    ws[`A${footerRowIndex + 1}`].s = {
      font: { bold: true, sz: 12, color: { rgb: "000000" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin", color: { rgb: "000000" } },
        bottom: { style: "thin", color: { rgb: "000000" } },
        left: { style: "thin", color: { rgb: "000000" } },
        right: { style: "thin", color: { rgb: "000000" } },
      },
    };
    merges.push({
      s: { r: footerRowIndex, c: 0 },
      e: { r: footerRowIndex, c: totalCols - 1 },
    });

    // Add data rows to sheet
    XLSX.utils.sheet_add_aoa(ws, ws_data, { origin: dataOrigin });
    ws["!merges"] = merges;

    // Set column widths
    const columnWidths = ws_data[0].map((_, colIndex) => ({
      wch:
        Math.max(
          ...ws_data.map((row) =>
            row[colIndex]
              ? row[colIndex]
                  .toString()
                  .split("\n")
                  .reduce((max, line) => Math.max(max, line.length), 0)
              : 0
          )
        ) + 7,
    }));
    ws["!cols"] = columnWidths;

    // Set row heights
    ws["!rows"] = ws_data.map((row, idx) => {
      if (idx === 0) return { hpt: 25 };
      const lawDataCell = row[lawColIndex] || "";
      const lineCount = lawDataCell.toString().split("\n").length;
      return { hpt: Math.max(25, lineCount * 20) };
    });

    // Add heights for header rows
    for (let i = 0; i < headerRowIndex; i++) {
      ws["!rows"].unshift({ hpt: 30 });
    }

    // Append sheet to workbook and download
    XLSX.utils.book_append_sheet(wb, ws, "Report");
    XLSX.writeFile(wb, `${file_name}.xlsx`);
  };

  download_csv = () => {
    const { t, language } = this.context;
    const { showList } = this.state;
    const report_name = "Accused_Details";

    const file_name = `${report_name}_${moment().format("DDMMMYYYY")}`;

    const ReportTitle = "आरोपीची माहिती";

    let list = [];
    const showSubheading = this.state.selectedFilter === "लघु शीर्षक";
    list =
      this.state.filterData &&
      this.state.filterData.map((data, index) => {
        let obj = {
          [t("sr.no")]: index + 1,
          Id: data.masterId,
          [t("name")]: data.name ? data.name : "-",
          [t("address")]: data.address ? data.address : "-",
          [t("age")]: data.age ? data.age : "-",
          [t("total_crimes")]: data.totalCrimeCount
            ? data.totalCrimeCount
            : "-",
          [t("accused_police_station")]: data.districtName,
          [t("photo")]:
            data?.photo?.length > 0 && data.photo[0] !== ""
              ? t("yes")
              : t("no"),
        };
        if (showSubheading) {
          obj[t("sub_title")] =
            data?.subheadings?.length > 0 ? data.subheadings.join(", ") : "";
        }
        return obj;
      });
    console.log("list", list);

    var arrData = list;

    console.log("arrData", arrData);

    const ws = XLSX.utils.json_to_sheet(arrData, { origin: "A4" });

    const columnWidths = Object.keys(arrData[0]).map((key) => ({
      wch:
        Math.max(
          key.length,
          ...arrData.map((row) => String(row[key] || "").length)
        ) + 6,
    }));

    ws["!cols"] = columnWidths;

    const headerStyle = {
      font: { bold: true, sz: 12 },
      alignment: {
        horizontal: "center",
        vertical: "center",
        wrapText: true,
      },
    };
    const cellStyle = {
      font: { sz: 12 },
      alignment: {
        horizontal: "center",
        vertical: "center",
        wrapText: true,
      },
    };
    Object.keys(arrData[0]).forEach((key, index) => {
      const cellRef = XLSX.utils.encode_cell({ r: 3, c: index }); // Headers are at row 3 (A3)
      if (!ws[cellRef]) ws[cellRef] = {}; // Ensure cell exists
      ws[cellRef].s = headerStyle;
    });
    arrData.forEach((row, rowIndex) => {
      Object.values(row).forEach((value, colIndex) => {
        const cellRef = XLSX.utils.encode_cell({
          r: rowIndex + 4,
          c: colIndex,
        }); // Data starts at row 4
        if (!ws[cellRef]) ws[cellRef] = {};
        ws[cellRef].s = cellStyle;
      });
    });

    const cityName = this.getCityName(this.props?.user?.cityId || "");
    const stateName = this.state.district_name;
    const headerData = `${stateName}(${cityName})`;
    ws["A1"] = {
      v: headerData,
      t: "s",
      s: headerStyle,
    };
    ws["A2"] = { v: ReportTitle, t: "s", s: headerStyle };
    console.log("language", language);

    const footerContent = `Generated At ${moment(new Date()).format(
      "DD MMM YYYY"
    )} From Criminal Monitoring Intelligent System`;

    const footerRowIndex = arrData.length + 6;

    XLSX.utils.sheet_add_aoa(ws, [[footerContent]], {
      origin: `A${footerRowIndex}`,
    });
    ws[`A${footerRowIndex}`].s = {
      font: { bold: true, sz: 12, color: { rgb: "000000" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
    };

    const mergeRanges = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: columnWidths.length - 1 } },
      { s: { r: 1, c: 0 }, e: { r: 1, c: columnWidths.length - 1 } },
      {
        s: { r: footerRowIndex - 1, c: 0 },
        e: { r: footerRowIndex - 1, c: columnWidths.length - 1 },
      },
    ];

    mergeRanges.push({
      s: { r: 2, c: 0 },
      e: { r: 2, c: columnWidths.length - 1 },
    });

    ws["!merges"] = mergeRanges;

    ws["!rows"] = Array(footerRowIndex).fill({ hpt: 25 });
    ws["!rows"][footerRowIndex - 1] = { hpt: 40 };

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Report");

    XLSX.writeFile(wb, `${file_name}.xlsx`);
  };
  showGunaViewModel = () => {
    this.setState({
      showGunaDetails: true,
    });
  };
  closeGunaViewModel = () => {
    this.setState({
      showGunaDetails: false,
    });
  };
  onGunaForm = (data) => {
    if (data) {
      this.setState({ gunaLoading: true });
      this.showGunaViewModel();
      this.props.dispatch(professionalAction.getCriminalsViewsById(data));
    }
  };

  openImageModal = (img, name) => {
    this.setState({ imageOpen: true, selectedImage: img, name: name });
  };

  closeImageModal = () => {
    this.setState({ imageOpen: false, selectedImage: null, name: null });
  };
  clear = () => {
    this.setState({
      filter: false,
      gunacount: false,
      searchText: "",
      search: false,
      issearch: false,
    });
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0] ? selectedKeys[0] : this.state.searchText}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => {
              this.handleSearch(selectedKeys, confirm, dataIndex);
              this.searchdata(selectedKeys[0]);
            }}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    // onFilter: (value, record) =>
    //   record[dataIndex]
    //     ? record[dataIndex]
    //         .toString()
    //         .toLowerCase()
    //         .includes(value.toLowerCase())
    //     : "",
    // onFilterDropdownVisibleChange: (visible) => {
    //   if (visible) {
    //     setTimeout(() => this.searchInput.select(), 100);
    //   }
    // },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  searchdata = async () => {
    this.setState({
      search: true,
      isLoading: true,
      criminalList1: [],
      issearch: true,
      total: 0,
    });
    const { selectedPoliceStation, searchText } = this.state;
    let obj = {
      value: selectedPoliceStation?.value,
      id: selectedPoliceStation?.id,
      searchText: searchText,
    };
    try {
      const response = await PoliceSideActions.PoliceSideCommonSearch(obj);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      let tempObj = data?.data?.map((res, index) => {
        return {
          ...res,
          "Sr.No": index + 1,
        };
      });
      console.log("data", data);
      this.setState({
        criminalList1: tempObj,
        isLoading: false,
        total: data.data.length,
        issearch: true,
      });
    } catch (error) {}
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({
      searchText: "",
      currentPage: 0,
      tota: 0,
      criminalList1: [],
    });
  };

  handleEditForm = (data) => {
    if (this.props.isAccusedFormUpdate && this.props.isAccusedFormUpdate) {
      this.props.onEditAccusedForm(data);
    } else {
      this.props.onEdituser(data);
    }
  };

  handlePreventiveViewForm = (data) => {
    if (this.props.isAccusedFormUpdate && this.props.isAccusedFormUpdate) {
      this.props.onPreventiveViewAccusedForm(data);
    } else {
      this.props.onPreventiveViewAccusedForm(data);
    }
  };

  handleViewForm = (data) => {
    this.props.onViewAccusedForm(data);
  };

  componentDidUpdate(prevProps) {
    // Check if the data has just arrived
    const prevList = prevProps.professionals?.criminalViewList?.gunhaInfor;
    const currList = this.props.professionals?.criminalViewList?.gunhaInfor;
    if (this.state.gunaLoading && prevList !== currList) {
      this.setState({ gunaLoading: false });
    }
  }

  filterkey = (e) => {
    this.setState({ key: e.key });
  };

  getPSCriminalsTableInfoByUserId = (orderBy, orderDirection) => {
    this.isLoading = true;
    this.setState({
      orderBy: orderBy,
      orderDirection: orderDirection,
    });
    professionalAction
      .getPSCriminalsTableInfoByUserId(
        this.props?.id,
        this.state.currentPage,
        this.state.pageSize,
        orderBy,
        orderDirection
      )
      .then((res) => {
        res &&
          res.text().then((criminalList1) => {
            let criminal = JSON.parse(criminalList1);
            let list = criminal.results;
            this.setState({
              criminalList1: list,
              isLoading: false,
              total: criminal.totalCount,
            });
            this.isLoading = false;
          });
      });
    this.setState({
      criminalList1: [],
      gunacount: true,
    });
  };

  searchfilter = (orderBy, orderDirection) => {
    this.isLoading = true;
    this.setState({
      orderBy: orderBy,
      orderDirection: orderDirection,
      isLoading: true,
      criminalList1: [],
    });
    if (this.state.searchText) {
      professionalAction
        .getFilterSearchCriminalsTableInfoByUserId(
          this.props.id,
          this.state.searchText,
          this.state.currentPage,
          this.state.pageSize,
          orderBy,
          orderDirection
        )
        .then((res) => {
          res &&
            res.text().then((criminalList1) => {
              let criminal = JSON.parse(criminalList1);
              let list = criminal.dataItem;
              this.setState({
                criminalList1: list,
                isLoading: false,
                total: criminal.totalItems,
              });
              this.isLoading = false;
            });
        });
      this.setState({
        criminalList1: [],
        filter: true,
      });
    } else {
      professionalAction
        .getFilterCriminalsTableInfoByUserId(
          this.props.id,
          this.state.currentPage,
          this.state.pageSize,
          orderBy,
          orderDirection
        )
        .then((res) => {
          res &&
            res.text().then((criminalList1) => {
              let criminal = JSON.parse(criminalList1);
              let list = criminal.dataItem;
              this.setState({
                criminalList1: list,
                isLoading: false,
                total: criminal.totalItems,
              });
              this.isLoading = false;
            });
        });
      this.setState({
        criminalList1: [],
        filter: true,
      });
    }
  };

  handleInputChange = (e) => {
    this.setState({ searchText: e.target.value });
  };

  cleardata = () => {
    this.setState({
      criminalList1: [],
    });
  };

  getSerialNumber = (index, currentPage, pageSize) => {
    return currentPage * pageSize + index + 1;
  };

  handleFind = async () => {
    this.setState({ isFilterActive: true, total: 0 });
    const { selectedHeadings, year } = this.state;
    console.log("selectedHeadings", selectedHeadings);
    this.setState({
      isLoading: true,
    });
    if (this.state.year.length > 0) {
      this.setState({
        is_year: true,
      });
    }
    const payload = {
      userid: this.props?.id,
      heading: selectedHeadings.length > 0 && selectedHeadings,
      year: year.length > 0 && year,
      searchText:
        this.state.select_dropdown === "search_guna" && this.state.searchGuna,
      searchId:
        this.state.select_dropdown === "search_id" && this.state.searchGuna,
    };

    try {
      const response =
        await professionalAction.getCriminalsFilledPoliceStationHeadingFilter(
          payload
        );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("data", data);
      this.setState({
        filterData: data.data,
        isLoading: false,
        total: data.data.length,
      });
    } catch (error) {}
  };
  getPhotoStatusFilterByUserId = (photo_status) => {
    this.setState({ isFilterActive: true, photoStatus: photo_status });
    this.setState({
      isLoading: true,
    });

    const payload = {
      id: this.props?.id,
      photo_status: photo_status,
    };
    professionalAction.getPhotoStatusFilterByUserId(payload).then((res) => {
      this.setState({
        filterData: res.rows,
        isLoading: false,
        total: res.count,
      });
    });
  };

  handleTitleFind = async () => {
    this.setState({ isFilterActive: true, total: 0 });
    const { crimeTitle, photoStatus } = this.state;
    this.setState({
      isLoading: true,
    });

    if (this.state.year.length > 0) {
      this.setState({
        is_year: true,
      });
    }
    const payload = {
      userid: this.props?.id,
      heading: crimeTitle,
      year: this.state.year.length > 0 && this.state.year,
      rulesName: this.state.kayda,
      kalam: this.state.kalam,
      crime_title:
        this.state.selectedFilter === "मोडस" &&
        this.state.crime_type.length > 0 &&
        this.state.crime_type,
    };

    try {
      const response =
        await professionalAction.getGunaHeadingFilledPoliceStationArophiFilter(
          payload
        );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      this.setState({
        filterData: data?.results,
        isLoading: false,
        total: data?.results.length,
      });
    } catch (error) {}
  };

  clearFilter = () => {
    this.setState({
      filter: false,
      searchText: "",
      search: false,
      filter: false,
      gunacount: false,
      searchText: "",
      search: false,
      issearch: false,
      isFilterActive: false,
      filterData: [],
      selectedFilter: "",
      selectedHeadings: [],
      crimeTitle: [],
      year: [],
      is_year: false,
      total: 0,
      is_photo: false,
      photo_status: null,
      orderDirection: "",
      orderBy: "",
      is_guna: false,
      searchGuna: "",
      kayda: "",
      kalam: [],
      select_main_head: "",
      crime_type: [],
    });
  };

  handleYear = (e) => {
    this.setState({ year: e });
  };
  getGunaWiseYear = () => {
    this.setState({
      filterData: [],
      isLoading: true,
      isFilterActive: true,
      is_year: true,
    });
    const temp = {
      id: this.props.id,
      year: this.state.year,
    };
    professionalAction.gunaYearWiseFilledAPI(temp).then((res) => {
      res &&
        // let criminal = JSON.parse(criminalList1);
        // let list = criminal.dataItem;
        this.setState({
          filterData: res.results,
          isLoading: false,
          total: res.results.length,
        });
    });
  };
  handlePhoto = (e) => {
    this.setState({
      photoStatus: e.target.value,
    });
  };
  showDownloadPopup = () => {
    this.setState({
      is_download: true,
    });
  };
  closeDownloadPopup = () => {
    this.setState({
      is_download: false,
    });
  };
  onchangeSearch = (e) => {
    this.setState({
      select_dropdown: e,
      searchText: "",
      searchGuna: "",
      issearch: false,
      search: false,
    });
  };

  getPoliceStationWithGhatak = () => {
    const { user } = this.props;

    professionalAction
      .getPoliceStationWithGhatak(user.id)
      .then(async (res) => {
        if (!res.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await res.json();

        const cityOptions = data?.city
          ? [
              {
                id: data.city.id,
                label: `${data.city.value} (${data.city.City})`,
                value: data.city.value,
              },
            ]
          : [];

        const policeStationOptions = data?.distincts
          ? [
              {
                id: data?.distincts.id,
                label: `${data?.distincts?.value} (${data?.distincts?.DistrictName})`,
                value: data?.distincts?.value,
              },
            ]
          : [];

        this.setState({
          dataList: [...policeStationOptions, ...cityOptions],
          selectedPoliceStation: policeStationOptions[0]?.value,
        });
        this.handleSelectChange(policeStationOptions[0]?.value);
        this.setState({ districtName1: data?.distincts?.DistrictName });
      })
      .catch((error) => {})
      .finally(() => {});
  };

  handleSelectChange = (value) => {
    const selected = this.state.dataList.find((item) => item.value === value);
    this.setState({
      selectedPoliceStation: selected,
    });
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page - 1 }, () => {
      if (this.state.filter) {
        this.searchfilter(this.state.orderBy, this.state.orderDirection);
      }
    });
  };

  handleKala = (e) => {
    this.setState({
      kayda: e,
    });
    this.props.dispatch(professionalAction.getKalam(e));
  };
  render() {
    console.log("gunaLoading", this.state.gunaLoading);
    const {
      selectedHeadings,
      crimeTitle,
      selectedFilter,
      photoStatus,
      is_photo,
      select_dropdown,
      dataList,
    } = this.state;
    console.log("selectedPoliceStation", this.state.selectedPoliceStation);
    const { pc_crimetypes, pc_crimetitles, professionals } = this.props;
    const requiredSerchColumn = ["mobileNumber", "name", "districtName"];
    const requiredSortColumn = ["gunhaCount", "age"];
    const requiredSearchAndSort = ["name", "districtName", "address"];
    const requiredFilterColumn = ["photo"];
    const users = this.props.usersData;
    const { t } = this.context;
    console.log("app table props=>", this.props);
    const { year } = this.state;

    // Generate year options from 2010 to current year
    const currentYear = new Date().getFullYear();
    const yearOptions = [];
    for (let y = 2010; y <= 2025; y++) {
      yearOptions.push(y);
    }
    let columns = this.props.columns.map((res, index) => {
      let column = { ...res };

      // Customize "Sr.No" column
      if (res.title === "Sr.No") {
        column = {
          ...column,
          title: t("sr.no"),
          dataIndex: "Sr.No",
          key: "Sr.No",
          render: (_, __, rowIndex) => rowIndex + 1,
        };
      }

      return column;
    });

    // Find index of the "Sr.No" column
    const srNoIndex = columns.findIndex((col) => col.key === "Sr.No");

    // Create the "name" column
    const nameColumn = {
      title: t("name"),
      key: "name",
      render: (text, record) => <span title={record.id}>{record.name}</span>,
    };

    // Insert the name column after "Sr.No"
    if (srNoIndex !== -1) {
      columns.splice(srNoIndex + 1, 0, nameColumn);
    } else {
      // Fallback: if "Sr.No" not found, push at the end
      columns.push(nameColumn);
    }

    columns.push({
      title: t("total_crimes"),
      key: "total_count",
      render: (text, record) => (
        <div className="action-links-responsive">
          <Button
            type="text"
            size="small"
            className="action-link update-link"
            onClick={() => {
              this.onGunaForm(record.id);
            }}
          >
            {record.gunhaCount}
          </Button>
        </div>
      ),
    });
    columns.push({
      ...{
        title: t("photo"),
        key: "photo",
        // filters: [
        //   {
        //     text: "फोटो",
        //     value: 1,
        //   },
        //   {
        //     text: "नाही",
        //     value: null,
        //   },
        // ],
        // onFilter: (value, record) => {
        //   if (value) {
        //     return record.photo ? record.photo.split().length === value : null;
        //   } else {
        //     return record.photo === value;
        //   }
        // },
        render: (text, record) => (
          <Space size="middle">
            {record.photo &&
            record.photo.length > 0 &&
            record.photo[0].trim() !== "" ? (
              <img
                style={{ width: 50, height: 50 }}
                src={
                  "https://pcimageupload.s3.ap-south-1.amazonaws.com/" +
                  record.photo
                }
                onClick={() => this.openImageModal(record.photo, record.name)}
              ></img>
            ) : (
              "नाही"
            )}
          </Space>
        ),
      },
    });

    columns.push({
      ...{
        title: t("action"),
        key: "action",
        render: (text, record) => (
          <div className="action-links-responsive">
            <Button
              type="text"
              size="small"
              className="action-link update-link"
              onClick={() => this.handleEditForm(record)}
            >
              {t("update")}
            </Button>
            <Button
              type="text"
              size="small"
              className="action-link update-link"
              onClick={() => this.handleViewForm(record.id)}
            >
              {t("view1")}
            </Button>
            <Button
              type="text"
              size="small"
              className="action-link update-link"
              onClick={() => this.handlePreventiveViewForm(record.id)}
            >
              {t("preventive")}
            </Button>
          </div>
        ),
      },
    });
    console.log("columns", columns);

    const menu = (
      <Menu onClick={this.filterkey}>
        <Menu.Item key="name">
          {t("sort_by_name")}
          <ArrowDownOutlined
            onClick={() => {
              this.searchfilter("name", "ASC");
            }}
          ></ArrowDownOutlined>
          <ArrowUpOutlined onClick={() => this.searchfilter("name", "DESC")} />
        </Menu.Item>
        <Menu.Item key="age">
          {t("sort_by_age")}
          <ArrowDownOutlined
            onClick={() => {
              this.setState({
                orderDirection: "ASC",
              });
              this.searchfilter("age", "ASC");
            }}
          ></ArrowDownOutlined>
          <ArrowUpOutlined onClick={() => this.searchfilter("age", "DESC")} />
        </Menu.Item>
        <Menu.Item key="districtName">
          {users && users.role === "2"
            ? t("sort_by_police_station")
            : t("sort_by_district_name")}
          <ArrowDownOutlined
            onClick={() => {
              this.searchfilter("districtName", "ASC");
            }}
          ></ArrowDownOutlined>
          <ArrowUpOutlined
            onClick={() => this.searchfilter("districtName", "DESC")}
          />
        </Menu.Item>
        <Menu.Item key="districtName">
          {t("sort_by_total_crimes")}
          <ArrowDownOutlined
            onClick={() => {
              this.getPSCriminalsTableInfoByUserId("id", "ASC");
              this.setState({ gunacount: true });
            }}
          ></ArrowDownOutlined>
          <ArrowUpOutlined
            onClick={() => {
              this.getPSCriminalsTableInfoByUserId("id", "DESC");
              this.setState({ gunacount: true });
            }}
          />
        </Menu.Item>
      </Menu>
    );

    let total = this.state.total
      ? this.state.total
      : this.props.data.length > 0
      ? this.props.total_bharthili
      : "0";
    return (
      <>
        {this.props.report == true ? (
          ""
        ) : (
          <>
            <div className="filter-card">
              {/* First Row - Search + Photo */}
              <Row
                gutter={[16, 16]}
                align="middle"
                style={{ marginBottom: 12 }}
              >
                {/* Filter Dropdown */}
                <Col xs={24} sm={6} md={4}>
                  <Select
                    onChange={(e) => this.onchangeSearch(e)}
                    value={select_dropdown}
                    placeholder={t("select_filter_type")}
                    allowClear
                    style={{ width: "100%" }}
                  >
                    <Option value="search_name">{t("search_by_name")}</Option>
                    <Option value="search_guna">{t("search_by_guna")}</Option>
                    <Option value="search_id">{t("search_by_id")}</Option>
                  </Select>
                </Col>

                {/* Search Input Area */}
                <Col xs={24} sm={10} md={12}>
                  {select_dropdown === "search_name" && (
                    <Space style={{ width: "100%", gap: 8 }} wrap>
                      <Form.Item
                        style={{ marginBottom: 0, flexGrow: 1 }}
                        rules={[
                          {
                            required: true,
                            message: "Please select a police station",
                          },
                        ]}
                      >
                        <Select
                          style={{ width: "100%" }}
                          placeholder="Select value"
                          onChange={this.handleSelectChange}
                          value={this.state.selectedPoliceStation}
                          defaultValue={this.state.selectedPoliceStation}
                        >
                          {dataList &&
                            Array.isArray(dataList) &&
                            dataList.map((item) => (
                              <Select.Option key={item.id} value={item.value}>
                                {item.label}
                              </Select.Option>
                            ))}
                        </Select>
                      </Form.Item>

                      {this.state.selectedPoliceStation && (
                        <>
                          <Input
                            placeholder={t("search")}
                            value={this.state.searchText}
                            onChange={(e) =>
                              this.setState({ searchText: e.target.value })
                            }
                            allowClear
                            style={{ flexGrow: 1 }}
                          />
                          <Button
                            type="primary"
                            onClick={() => this.searchdata()}
                          >
                            {t("find")}
                          </Button>
                        </>
                      )}
                    </Space>
                  )}

                  {select_dropdown === "search_guna" && (
                    <Space style={{ width: "100%", gap: 8 }} wrap>
                      <Input
                        placeholder={t("search_cr_no")}
                        value={this.state.searchGuna}
                        onChange={(e) =>
                          this.setState({ searchGuna: e.target.value })
                        }
                        allowClear
                        style={{ flexGrow: 1 }}
                      />
                      {this.state.searchGuna.trim() !== "" && (
                        <Button
                          type="primary"
                          onClick={() => this.handleFind()}
                        >
                          {t("find")}
                        </Button>
                      )}
                    </Space>
                  )}

                  {select_dropdown === "search_id" && (
                    <Space style={{ width: "100%", gap: 8 }} wrap>
                      <Input
                        placeholder={t("search_id")}
                        value={this.state.searchGuna}
                        onChange={(e) =>
                          this.setState({ searchGuna: e.target.value })
                        }
                        onKeyPress={(event) => {
                          if (!/^[0-9\u0966-\u096F]$/.test(event.key))
                            event.preventDefault();
                        }}
                        onPaste={(event) => {
                          const pastedText =
                            event.clipboardData.getData("Text");
                          if (!/^[0-9\u0966-\u096F]+$/.test(pastedText))
                            event.preventDefault();
                        }}
                        allowClear
                        maxLength={10}
                        style={{ flexGrow: 1 }}
                      />
                      {this.state.searchGuna.trim() !== "" && (
                        <Button
                          type="primary"
                          onClick={() => this.handleFind()}
                        >
                          {t("find")}
                        </Button>
                      )}
                    </Space>
                  )}
                </Col>

                {/* Photo & Sort Section */}
                <Col xs={24} sm={8} md={8}>
                  <Space
                    wrap
                    style={{
                      width: "100%",
                      justifyContent: "flex-end",
                      gap: 8,
                    }}
                  >
                    <Button onClick={() => this.setState({ is_photo: true })}>
                      {t("photo")}
                    </Button>

                    {this.state.is_photo && (
                      <Radio.Group
                        value={photoStatus}
                        optionType="button"
                        buttonStyle="solid"
                        onChange={(e) =>
                          this.getPhotoStatusFilterByUserId(e.target.value)
                        }
                      >
                        <Radio.Button value="yes">{t("yes")}</Radio.Button>
                        <Radio.Button value="no">{t("no")}</Radio.Button>
                      </Radio.Group>
                    )}

                    <Dropdown
                      overlay={menu}
                      placement="bottomRight"
                      arrow={{ pointAtCenter: true }}
                    >
                      <Button type="default">{t("sorter_by")}</Button>
                    </Dropdown>
                  </Space>
                </Col>
              </Row>

              {/* Second Row - Full Width Filters */}
              <Row gutter={[16, 16]} style={{ marginTop: 12 }}>
                <Col span={24}>
                  <Row gutter={[16, 16]} justify="space-between" align="middle">
                    <Col xs={24} lg={18}>
                      <Space wrap style={{ width: "100%" }}>
                        <span className="filter-label">
                          {t("select_filter_type")}:
                        </span>
                        <Select
                          placeholder={t("select_filter_type")}
                          value={selectedFilter}
                          onChange={(val) =>
                            this.setState({
                              selectedFilter: val,
                              select_dropdown: null,
                            })
                          }
                          style={{ minWidth: 140, flex: 1 }}
                          allowClear
                          disabled={
                            this.state.is_photo ||
                            this.state.issearch == true ||
                            this.state.filter == true ||
                            this.state.is_guna == true
                          }
                        >
                          <Option value="शीर्षक">{t("title")}</Option>
                          <Option value="लघु शीर्षक">{t("sub_title")}</Option>
                          <Option value="मोडस">{t("modus_operandi")}</Option>
                          <Option value="कायदा">
                            {`${t("law")} / ${t("section")}`}
                          </Option>
                        </Select>

                        {selectedFilter === "लघु शीर्षक" && (
                          <Select
                            mode="multiple"
                            placeholder="Please select Crime Type"
                            value={selectedHeadings}
                            onChange={(val) =>
                              this.setState({ selectedHeadings: val })
                            }
                            style={{ minWidth: 220, flex: 1 }}
                            showSearch
                            maxTagCount={1}
                          >
                            {pc_crimetypes?.map((res) => (
                              <Option key={res.id} value={res.id}>
                                {res.crimetype}
                              </Option>
                            ))}
                          </Select>
                        )}

                        {selectedFilter === "शीर्षक" && (
                          <Select
                            mode="multiple"
                            allowClear
                            placeholder={t("please_select_a_title")}
                            value={crimeTitle}
                            onChange={(val) =>
                              this.setState({ crimeTitle: val })
                            }
                            style={{ minWidth: 220, flex: 1 }}
                            showSearch
                            maxTagCount={1}
                          >
                            {pc_crimetitles?.map((item) => (
                              <Option key={item.id} value={item.id}>
                                {item.crime_title}
                              </Option>
                            ))}
                          </Select>
                        )}
                        {selectedFilter === "कायदा" && (
                          <Select
                            allowClear
                            placeholder={t("please_select_an_option")}
                            value={this.state.kayda}
                            onChange={(val) => this.handleKala(val)}
                            style={{ minWidth: 220, flex: 1 }}
                            showSearch
                            maxTagCount={1}
                            filterOption={(input, option) =>
                              option?.children
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                          >
                            {professionals?.pc_acts?.map((item) => (
                              <Option key={item.act_cd} value={item.act_cd}>
                                {item.kayda}
                              </Option>
                            ))}
                          </Select>
                        )}
                        {this.state.kayda && selectedFilter === "कायदा" && (
                          <Select
                            filterOption={(input, option) =>
                              option?.children
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            optionFilterProp="children"
                            mode="multiple"
                            allowClear
                            placeholder="Please select option"
                            value={this.state.kalam}
                            onChange={(val) => this.setState({ kalam: val })}
                            style={{ minWidth: 220, flex: 1 }}
                            showSearch
                            maxTagCount={1}
                          >
                            {professionals?.pc_kalams?.map((item) => (
                              <Option key={item.section} value={item.section}>
                                {item.section}
                              </Option>
                            ))}
                          </Select>
                        )}
                        {selectedFilter === "मोडस" && (
                          <Select
                            mode="multiple"
                            filterOption={(input, option) =>
                              option?.children
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            optionFilterProp="children"
                            allowClear
                            placeholder="Please select option"
                            value={this.state.crime_type}
                            onChange={(val) =>
                              this.setState({ crime_type: val })
                            }
                            style={{ minWidth: 220, flex: 1 }}
                            showSearch
                            maxTagCount={1}
                          >
                            {this.state.main_head?.map((item) => (
                              <Option key={item.title_id} value={item.title_id}>
                                {item.main_head_type}
                              </Option>
                            ))}
                          </Select>
                        )}

                        <Select
                          mode="multiple"
                          allowClear
                          placeholder={t("crimes_year")}
                          value={year}
                          onChange={(val) => this.handleYear(val.map(Number))}
                          style={{ minWidth: 140, flex: 1 }}
                          showSearch
                          maxTagCount={1}
                          disabled={
                            this.state.is_photo ||
                            this.state.issearch == true ||
                            this.state.filter == true ||
                            this.state.is_guna == true
                          }
                        >
                          {yearOptions.map((y) => (
                            <Option key={y} value={y}>
                              {y}
                            </Option>
                          ))}
                        </Select>
                      </Space>
                    </Col>

                    <Col xs={24} lg={6} style={{ textAlign: "right" }}>
                      {(this.state.year.length > 0 ||
                        this.state.crimeTitle.length > 0 ||
                        this.state.selectedHeadings.length > 0 ||
                        this.state.kalam.length > 0 ||
                        this.state.crime_type.length > 0) && (
                        <Button
                          type="primary"
                          onClick={
                            this.state.selectedFilter === "शीर्षक" ||
                            this.state.selectedFilter === "मोडस"
                              ? this.handleTitleFind
                              : this.state.selectedFilter === "लघु शीर्षक"
                              ? this.handleFind
                              : this.handleTitleFind
                          }
                          style={{ marginRight: 8 }}
                          block={window.innerWidth < 768} // full width on small screens
                        >
                          {t("find")}
                        </Button>
                      )}
                      {(this.state.is_year ||
                        this.state.issearch ||
                        this.state.searchText ||
                        this.state.isFilterActive ||
                        this.state.filter) && (
                        <Button
                          danger
                          onClick={() => this.clearFilter()}
                          block={window.innerWidth < 768} // full width on small screens
                        >
                          {t("clear")}
                        </Button>
                      )}
                    </Col>
                  </Row>
                </Col>
              </Row>

              {/* Third Row - Download */}
              <Row gutter={[16, 16]} style={{ marginTop: 12 }}>
                <Col span={24}>
                  <Space wrap>
                    <Form
                      ref={this.formRef}
                      onFinish={this.handleFinish}
                      initialValues={{ condition: this.state.download }}
                    >
                      <Form.Item
                        name="condition"
                        rules={[
                          {
                            required: true,
                            message: "Please select a value",
                          },
                        ]}
                        style={{ marginBottom: 0 }}
                      >
                        <Select
                          placeholder="Please select an option"
                          value={this.state.download} // controlled by state
                          onChange={this.handleChange} // updates state + Form
                          style={{ minWidth: 160 }}
                        >
                          <Option value="excel">{t("excel")}</Option>
                          <Option value="guna_excel">
                            {t("crime_statistics")}
                          </Option>
                        </Select>
                      </Form.Item>
                    </Form>

                    {this.state.download && (
                      <Button
                        type="primary"
                        onClick={() => {
                          if (
                            !this.state.selectedFilter &&
                            this.state.filterData.length === 0
                          ) {
                            this.showDownloadPopup();
                          } else {
                            this.downloadReport();
                          }
                        }}
                      >
                        {t("download")}
                      </Button>
                    )}
                  </Space>
                </Col>
              </Row>
            </div>
          </>
        )}
        <div
          style={{
            padding: "4px 12px",
            background: "#fff",
            borderRadius: "4px",
            border: "1px solid #d9d9d9",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            width: "8%",
            marginBottom: "10px",
          }}
        >
          <span style={{ color: "#666" }}>{t("total")}:</span>
          <span style={{ fontWeight: "bold" }}>{total}</span>
        </div>
        {this.state.search == true ||
        this.state.filter == true ||
        this.state.gunacount == true ? (
          <FindAccusedBaseSearchTable
            search={this.state.searchText}
            clear={this.clear}
            isAccusedFormUpdate={true}
            onEditAccusedForm={this.handleEditForm}
            onPreventiveViewAccusedForm={this.handlePreventiveViewForm}
            onViewAccusedDetails={this.handleViewForm}
            onCriminalActiveStatus={this.handleActiveCriminal}
            criminalRecords={this.state.criminalList1}
            columns={columns}
            usersData={this.props.usersData}
            current={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.state.total}
            handlePageChange={this.handlePageChange}
            handlePageSizeChange={this.handlePageSizeChange}
            isseach={this.props.isseach}
            cityid={users?.cityid ? users?.cityid : this.props?.cityid}
            id={this.props?.id}
            cleardata={this.cleardata}
            getSerialNumber={this.getSerialNumber}
            loading={this.state.isLoading}
            professionals={professionals}
            user={this.props?.user}
          />
        ) : this.state.isFilterActive == true ? (
          <FilterData
            clear={this.clear}
            isAccusedFormUpdate={true}
            onEditAccusedForm={this.handleEditForm}
            onPreventiveViewAccusedForm={this.handlePreventiveViewForm}
            onViewAccusedDetails={this.handleViewForm}
            onCriminalActiveStatus={this.handleActiveCriminal}
            criminalRecords={this.state.filterData}
            columns={columns}
            usersData={this.props.usersData}
            current={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.state.total}
            handlePageChange={this.handlePageChange}
            handlePageSizeChange={this.handlePageSizeChange}
            isseach={this.props.isseach}
            cityid={users.cityId ? users.cityId : this.props.cityid}
            cleardata={this.cleardata}
            getSerialNumber={this.getSerialNumber}
            loading={this.state.isLoading}
            professionals={professionals}
            isFilterActive={this.state.isFilterActive}
            selectedFilter={this.state.selectedFilter}
            photo_status={photoStatus}
            is_year={this.state.is_year}
            handleEditForm={this.handleEditForm}
            search_type={this.state.select_dropdown}
            handlePreventiveViewForm={this.handlePreventiveViewForm}
            user={this.props?.user}
          ></FilterData>
        ) : (
          <Table
            columns={columns}
            dataSource={this.props.data}
            pagination={{
              current: this.props.currentPage,
              pageSize: this.props.pageSize,
              total: this.props.total,
              onChange:
                this.props?.accusedDrawer == true
                  ? this.props.onTableChange
                  : this.props.handlePageChange,
              has_previous: this.props.pageSize > 1,
              previous: this.props.pageSize - 1,
              has_next: this.props.pageSize < this.props.total,
              next: this.props.total + 1,
              last_page: Math.ceil(this.props.total / this.props.pageSize),
              onShowSizeChange: this.props.handlePageSizeChange,
              // onChange: this.props.onTableChange,
              // showSizeChanger: true,
              // showQuickJumper: true,
            }}
          />
        )}
        {this.state.imageOpen && (
          <ImageView
            imageOpen={this.state.imageOpen}
            imageUrl={
              "https://pcimageupload.s3.ap-south-1.amazonaws.com/" +
              this.state.selectedImage
            }
            name={this.state.name}
            onClose={this.closeImageModal}
          />
        )}
        {this.state.showGunaDetails == true && (
          <Modal
            title={t("crime_information")}
            top
            visible={this.state.showGunaDetails}
            onOk={this.closeGunaViewModel}
            onCancel={this.closeGunaViewModel}
            width={95 + "%"}
          >
            <ViewGunaDetails
              pc_crimetitles={pc_crimetitles}
              dataStates={
                Array.isArray(professionals?.criminalViewList?.gunhaInfor) &&
                professionals?.criminalViewList?.gunhaInfor.length > 0
                  ? professionals?.criminalViewList?.gunhaInfor
                  : []
              }
              name={
                Array.isArray(professionals?.criminalViewList?.basicInfo) &&
                professionals?.criminalViewList?.basicInfo[0]
                  ? professionals?.criminalViewList?.basicInfo[0].name
                  : ""
              }
              address={
                Array.isArray(professionals?.criminalViewList?.basicInfo) &&
                professionals?.criminalViewList?.basicInfo[0]
                  ? professionals?.criminalViewList?.basicInfo[0].address
                  : ""
              }
              loading={this.state.gunaLoading}
              user_details={this.props?.user}
              masterId={
                Array.isArray(professionals?.criminalViewList?.basicInfo) &&
                professionals?.criminalViewList?.basicInfo[0]
                  ? professionals?.criminalViewList?.basicInfo[0].id
                  : ""
              }
              closeGunaViewModel={this.closeGunaViewModel}
            ></ViewGunaDetails>
          </Modal>
        )}
        {this.state.is_download && (
          <Modal
            title="Confirm"
            open={this.state.is_download} // use `open` instead of deprecated `visible`
            onOk={this.closeDownloadPopup}
            onCancel={this.closeDownloadPopup}
            centered
            width="90%" // default responsive width
            style={{ maxWidth: 600 }} // ensures modal doesn't get too wide
            bodyStyle={{ wordWrap: "break-word" }}
          >
            <p style={{ fontSize: "1rem", textAlign: "center" }}>
              कृपया किमान एक <b>शीर्षक</b> किंवा <b>लघु शीर्षक</b> किंवा{" "}
              <b>कायदा/कलम</b> किंवा
              <b>गुन्हा दाखल वर्ष</b> निवडा
            </p>
          </Modal>
        )}
      </>
    );
  }
}
function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    users,
    professionals,
  };
}
const connectedAppTable = connect(mapStateToProps)(AppTable);
export { connectedAppTable as AppTable };
